import { UserToken } from '../../../shared/src/types/User';
import { baseApi } from '../app/baseApi'
import type { forgotPasswordInput, resetPasswordInput } from '../features/auth/authSchema';

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<{ message: string, user: UserToken }, { email: string; password: string }>
      ({
        query: (credentials) => ({
          url: 'auth/login',
          method: 'POST',
          body: credentials,
          credentials: 'include',
        })
      }),

    forgotPassword: builder.mutation<{ message: string }, forgotPasswordInput>({
      query: (body) => ({
        url: 'auth/forgot-password',
        method: 'POST',
        body,
      }),
    }),

    resetPassword: builder.mutation<{ message: string }, resetPasswordInput & { token: string }>({
      query: ({ token, ...body }) => ({
        url: 'auth/reset-password',
        method: 'POST',
        body: { ...body, token },
      }),
    }),

    refreshToken: builder.mutation<{ user:UserToken}, void>({
      query: () => ({
        url: 'auth/refresh',
        method: 'POST',
        body:{}
      }),
    }),

  }),
  overrideExisting: false,
})

export const { useLoginMutation, useForgotPasswordMutation, useResetPasswordMutation,useRefreshTokenMutation} = authApi